import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <div className="header-contents">
        <h2>Order your favourite food here</h2>
        <p>
          Choose from a diverse menu featuring a delectable array of dishes
          crafted with the the finest your craving and elevate your dining
          exprience,one delicious meal at home
        </p>
        <button>View Menu</button>
      </div>
    </div>
  );
};

export default Header;
